module.exports = __webpack_public_path__ + "static/media/soucoupe_big.a1d6aa7b.svg";